module.exports = __webpack_public_path__ + "img/Malus_domestica.e06675db.jpg";